import axios from 'axios';
import authHeader from './authHeader';

const API_URL = '/api/users/';

const getUsers = () => {
  return axios.get(API_URL, { headers: authHeader() });
};

const updateUser = (id, userData) => {
  return axios.put(API_URL + id, userData, { headers: authHeader() });
};

const createUser = (userData) => {
  return axios.post(API_URL, userData, { headers: authHeader() });
};

const softDeleteUser = (id) => {
  return axios.delete(API_URL + id, { headers: authHeader() });
};

const restoreUser = (id) => {
  return axios.post(API_URL + id + '/restore', {}, { headers: authHeader() });
};

const changeOwnPassword = (password) => {
  return axios.put(API_URL + 'me/password', { password }, { headers: authHeader() });
};

const userService = {
  getUsers,
  updateUser,
  createUser,
  softDeleteUser,
  restoreUser,
  changeOwnPassword,
};

export default userService;